/**
 * Maxi — Perguntas + Avaliações
 * Layout custom + Judge.me (mesmo lugar da coluna de compra)
 */
(function () {
  'use strict';

  var PAGE_SIZE = 3;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getReviewItems(root) {
    return qsa(root, '.jdgm-rev-widg__reviews .jdgm-rev, .jdgm-rev-widg .jdgm-rev, .jdgm-review-widget .jdgm-rev').filter(function (el) {
      return !el.classList.contains('jdgm-question') && !el.closest('.jdgm-qna, .jdgm-questions, .jdgm-quest-wrapper');
    });
  }

  function getJudgeLoadMore(root) {
    return (
      qs(root, '.jdgm-paginate__load-more') ||
      qs(root, '.jdgm-paginate a[data-page]') ||
      qs(root, '.jdgm-paginate .jdgm-btn')
    );
  }

  function getReportedTotal(root) {
    var widg = qs(root, '.jdgm-rev-widg');
    if (widg) {
      var n = parseInt(widg.getAttribute('data-number-of-reviews'), 10);
      if (!isNaN(n) && n > 0) return n;
    }

    var countEl = qs(root, '.maxi-qa__reviews-count');
    if (countEl) {
      var m = (countEl.textContent || '').match(/(\d+)/);
      if (m) return parseInt(m[1], 10);
    }

    return 0;
  }

  function getQuestionsTab() {
    return qs(document, '.jdgm-subtab__name[data-tabname="questions"]');
  }

  function getReviewsTab() {
    return qs(document, '.jdgm-subtab__name[data-tabname="reviews"]');
  }

  function clearAskInput(root) {
    var input = qs(root, '.maxi-qa__ask-input, input[name="question"]');
    if (!input) return;
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function showAskStatus(root, message) {
    var status = qs(root, '[data-maxi-qa-status]');
    if (!status) return;
    status.textContent = message || 'Pergunta enviada';
    status.hidden = false;
    window.clearTimeout(showAskStatus._t);
    showAskStatus._t = window.setTimeout(function () {
      status.hidden = true;
    }, 5000);
  }

  function hideAskStatus(root) {
    var status = qs(root, '[data-maxi-qa-status]');
    if (status) status.hidden = true;
  }

  function neutralizeJudgeAnchors(root) {
    var links = qsa(root, 'a[href^="#judgeme"], a[href="#product-reviews"], a.jdgm-cancel-question');
    qsa(document, 'a.jdgm-cancel-question').forEach(function (link) {
      if (links.indexOf(link) === -1) links.push(link);
    });

    links.forEach(function (link) {
      if (link.dataset.maxiHashSafe === 'true') return;
      if (link.hasAttribute('data-maxi-scroll-to')) return;
      if (link.classList.contains('product-meta__reviews-badge')) return;
      if (link.classList.contains('product-meta__features-link')) return;
      if (link.closest('.product-meta__rating-nav')) return;
      link.dataset.maxiHashSafe = 'true';
      link.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
      if ((link.getAttribute('href') || '').charAt(0) === '#') {
        link.setAttribute('href', 'javascript:void(0)');
        link.setAttribute('role', 'button');
      }
    });
  }

  function preventHashVisits(root) {
    if (root.dataset.maxiHashBound === 'true') return;
    root.dataset.maxiHashBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('a[href^="#"]');
        if (!link) return;
        if (link.hasAttribute('data-maxi-scroll-to')) return;
        if (link.classList.contains('product-meta__reviews-badge')) return;
        if (link.classList.contains('product-meta__features-link')) return;
        if (!root.contains(link) && !link.classList.contains('jdgm-cancel-question')) return;
        var href = link.getAttribute('href') || '';
        if (
          href === '#judgeme_product_reviews' ||
          href.indexOf('#judgeme') === 0 ||
          href === '#product-reviews'
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function scrollToSection(id) {
    var target = document.getElementById(id);
    if (!target) return false;

    if (id === 'product-description') {
      var collapseBtn = target.querySelector('[data-action="toggle-collapsible"]');
      if (collapseBtn && collapseBtn.getAttribute('aria-expanded') === 'false') {
        collapseBtn.click();
      }
      var viewMore = target.querySelector('.expandable-content[aria-expanded="false"] .expandable-content__toggle');
      if (viewMore) viewMore.click();
    }

    if (id === 'product-reviews') {
      var qaRoot = qs(document, '[data-maxi-qa]');
      if (qaRoot) {
        qaRoot.classList.remove('is-showing-questions');
        updateSectionTitle(qaRoot, false);
        updateQuestionsCount(qaRoot);
      }
    }

    var header = qs(document, '#shopify-section-header, .shopify-section--header, .header');
    var offset = (header && header.offsetHeight) || 80;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function bindProductNavLinks() {
    if (document.documentElement.dataset.maxiProductNavBound === 'true') return;
    document.documentElement.dataset.maxiProductNavBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('[data-maxi-scroll-to]');
        if (!link) return;
        var id = link.getAttribute('data-maxi-scroll-to');
        if (!id) return;
        event.preventDefault();
        event.stopPropagation();
        scrollToSection(id);
      },
      true
    );
  }

  function enhanceJudgePreviewBadge() {
    qsa(document, '.jdgm-prev-badge, .jdgm-preview-badge, a.jdgm-prev-badge').forEach(function (badge) {
      if (badge.closest('.product-meta__reviews-badge')) return;
      badge.setAttribute('data-maxi-scroll-to', 'product-reviews');
      badge.setAttribute('href', '#product-reviews');
      badge.classList.add('product-meta__reviews-badge');

      var text = qs(badge, '.jdgm-prev-badge__text, .jdgm-link-text, [class*="badge__text"]');
      if (text) {
        var match = (text.textContent || '').match(/(\d+)/);
        if (match) text.textContent = '(' + match[1] + ')';
      }
    });
  }

  function questionsAreLoaded() {
    return !!qs(document, '.jdgm-quest-widg__body .jdgm-quest');
  }

  function clearPanelInlineStyles() {
    [
      '.jdgm-rev-widg__body',
      '.jdgm-rev-widg__reviews',
      '.jdgm-quest-widg__body'
    ].forEach(function (sel) {
      qsa(document, sel).forEach(function (el) {
        el.style.removeProperty('display');
        el.style.removeProperty('height');
        el.style.removeProperty('max-height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('padding');
        el.style.removeProperty('padding-top');
        el.style.removeProperty('padding-bottom');
        el.style.removeProperty('margin');
        el.style.removeProperty('margin-top');
        el.style.removeProperty('margin-bottom');
        el.style.removeProperty('opacity');
        el.hidden = false;
      });
    });
  }

  function updateSectionTitle(root, questionsMode) {
    var title = qs(root, '.maxi-qa__reviews-title');
    if (!title) return;
    if (!title.dataset.maxiReviewsHtml) {
      title.dataset.maxiReviewsHtml = title.innerHTML;
    }
    if (questionsMode) {
      title.textContent = 'Perguntas e respostas';
    } else {
      title.innerHTML = title.dataset.maxiReviewsHtml;
    }
  }

  function hideJudgeQuestionSuccess(root) {
    var scope = root || document;
    qsa(scope, '.jdgm-form__done, .jdgm-form-done, .jdgm-question-form__done, .jdgm-notification, .jdgm-form__success, .jdgm-success, [class*="form__done"], [class*="success-message"]').forEach(function (el) {
      if (el.closest && el.closest('[data-maxi-qa-status]')) return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('hidden', '');
      el.setAttribute('data-maxi-success-hidden', 'true');
    });

    qsa(scope, '.maxi-qa__ask, .jdgm-question-form-wrapper, .jdgm-question-form, .jdgm-rev-widg__header').forEach(function (container) {
      qsa(container, 'div, section, p, h1, h2, h3, h4').forEach(function (el) {
        if (el.closest && el.closest('[data-maxi-qa-status]')) return;
        if (el.getAttribute('data-maxi-qa-status') != null) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/pergunta enviada/i.test(text)) return;
        if (!/obrigado pela sua pergunta|notific/i.test(text) && text.length < 40) return;
        // Só o bloco grande do Judge.me (não o status verde curto)
        if (el.classList && el.classList.contains('maxi-qa__ask-status')) return;
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('hidden', '');
        el.setAttribute('data-maxi-success-hidden', 'true');
      });
    });
  }

  function setQuestionsMode(root, on) {
    clearPanelInlineStyles();
    if (on) {
      root.classList.add('is-showing-questions');
    } else {
      root.classList.remove('is-showing-questions');
    }
    updateSectionTitle(root, on);
    updateQuestionsCount(root);
    neutralizeJudgeAnchors(root);
  }

  function ensureQuestionsLoaded(done) {
    if (questionsAreLoaded()) {
      if (done) done(true);
      return;
    }

    var questionsTab = getQuestionsTab();
    if (!questionsTab) {
      if (done) done(false);
      return;
    }

    // Uma única carga: clica a aba só para popular o DOM, depois limpa estilos
    // do Judge.me e deixa o CSS nosso controlar.
    if (ensureQuestionsLoaded._busy) {
      if (done) done(false);
      return;
    }
    ensureQuestionsLoaded._busy = true;

    var y = window.scrollY || window.pageYOffset || 0;
    var lockScroll = function () {
      if (Math.abs((window.scrollY || 0) - y) > 1) {
        window.scrollTo(0, y);
      }
    };
    var lockId = window.setInterval(lockScroll, 50);
    var origIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {};

    questionsTab.click();
    window.setTimeout(function () {
      clearPanelInlineStyles();
      Element.prototype.scrollIntoView = origIntoView;
      window.clearInterval(lockId);
      window.scrollTo(0, y);
      ensureQuestionsLoaded._busy = false;
      if (done) done(questionsAreLoaded());
    }, 550);
  }

  function getProductMeta(root) {
    var widget =
      qs(root, '.jdgm-review-widget') ||
      qs(document, '.jdgm-review-widget#judgeme_product_reviews') ||
      qs(document, '.jdgm-review-widget');

    var id =
      (widget && widget.getAttribute('data-id')) ||
      (root && root.getAttribute('data-product-id')) ||
      '';

    var title =
      (widget && widget.getAttribute('data-product-title')) ||
      (root && root.getAttribute('data-product-title')) ||
      '';

    var handle =
      (root && root.getAttribute('data-product-handle')) ||
      '';

    if (!handle) {
      var parts = (window.location.pathname || '').split('/').filter(Boolean);
      var pIdx = parts.indexOf('products');
      if (pIdx >= 0 && parts[pIdx + 1]) handle = parts[pIdx + 1];
      else if (parts.length) handle = parts[parts.length - 1];
    }

    return { id: String(id || ''), title: title || '', handle: handle || '' };
  }

  function ensureQuestionProductShell(root, wrap) {
    if (!wrap) return null;
    var meta = getProductMeta(root);
    if (!meta.id) return wrap.closest('.jdgm-review-widget');

    // Se o form ainda está dentro do widget nativo, só garante data-id
    var native = wrap.closest('.jdgm-review-widget:not(.maxi-qa__jm-product-shell)');
    if (native) {
      if (!native.getAttribute('data-id')) native.setAttribute('data-id', meta.id);
      if (meta.title && !native.getAttribute('data-product-title')) {
        native.setAttribute('data-product-title', meta.title);
      }
      return native;
    }

    // Form foi movido para o mount: cria um shell com a mesma assinatura do Judge.me
    var mount = qs(root, '[data-maxi-question-mount]') || qs(root, '.maxi-qa__ask');
    var shell = wrap.closest('.maxi-qa__jm-product-shell') || qs(mount, '.maxi-qa__jm-product-shell');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'jdgm-review-widget maxi-qa__jm-product-shell';
      if (mount) mount.appendChild(shell);
    }

    shell.setAttribute('data-id', meta.id);
    if (meta.title) shell.setAttribute('data-product-title', meta.title);
    if (meta.handle) shell.setAttribute('data-product-handle', meta.handle);

    if (wrap.parentElement !== shell) {
      shell.appendChild(wrap);
    }
    return shell;
  }

  function patchJudgeQuestionProductBinding(root) {
    if (!window.jdgm || typeof window.jdgm.getQuestionFormData !== 'function') return;
    if (window.jdgm.getQuestionFormData._maxiPatched) return;

    var original = window.jdgm.getQuestionFormData;
    window.jdgm.getQuestionFormData = function (formEl) {
      var data = original.call(this, formEl) || {};
      var meta = getProductMeta(root);
      var $form = formEl && formEl.jquery ? formEl : null;
      var node = $form ? $form[0] : formEl;
      if (node && node.nodeType === 1) {
        ensureQuestionProductShell(root, node.closest('.jdgm-question-form-wrapper') || node);
      }

      if (meta.id) data.id = meta.id;
      if (meta.title) data.product_title = meta.title;
      if (meta.handle) data.handle = meta.handle;
      return data;
    };
    window.jdgm.getQuestionFormData._maxiPatched = true;
  }

  function mountQuestionForm(root) {
    var wrap =
      qs(document, '.jdgm-question-form-wrapper') ||
      (qs(document, '.jdgm-question-form') && qs(document, '.jdgm-question-form').parentElement);
    var mount = qs(root, '[data-maxi-question-mount]') || qs(root, '.maxi-qa__ask');
    if (!wrap || !mount) return wrap;

    if (wrap.parentElement !== mount && !wrap.closest('.maxi-qa__jm-product-shell')) {
      mount.appendChild(wrap);
    }

    ensureQuestionProductShell(root, wrap);
    patchJudgeQuestionProductBinding(root);

    wrap.classList.add('is-open');
    wrap.style.setProperty('display', 'block', 'important');
    return wrap;
  }

  function closeQuestionForm(root) {
    root.classList.remove('is-asking');
    var wrap = qs(root, '.jdgm-question-form-wrapper') || qs(document, '.jdgm-question-form-wrapper');
    if (wrap) {
      wrap.classList.remove('is-open');
      wrap.style.setProperty('display', 'none', 'important');
    }
  }

  function openAskQuestion(root, prefill) {
    // Só abre o form nativo via CSS — sem trocar abas do Judge.me (evita “reload”)
    setQuestionsMode(root, false);
    root.classList.add('is-asking');
    hideAskStatus(root);

    var wrap = mountQuestionForm(root);
    neutralizeJudgeAnchors(root);
    patchJudgeQuestionProductBinding(root);

    var field =
      qs(document, '#jdgm_question_content') ||
      qs(document, 'textarea[name="question_content"]') ||
      qs(document, '.jdgm-question-form textarea');

    if (field && prefill) {
      field.value = prefill;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (wrap) {
      ensureQuestionProductShell(root, wrap);
      wrap.classList.add('is-open');
      wrap.style.setProperty('display', 'block', 'important');
    }
  }

  function showAllQuestions(root) {
    // Toggle só com CSS — sem clicar nas abas do Judge.me após a 1ª carga
    if (root.classList.contains('is-showing-questions')) {
      setQuestionsMode(root, false);
      return;
    }

    closeQuestionForm(root);

    function reveal() {
      setQuestionsMode(root, true);
    }

    if (questionsAreLoaded()) {
      reveal();
      return;
    }

    ensureQuestionsLoaded(function () {
      reveal();
    });
  }

  function updateQuestionsCount(root) {
    var label = qs(root, '[data-maxi-qa-all-label]');
    if (!label) return;

    if (root.classList.contains('is-showing-questions')) {
      label.textContent = 'Voltar às avaliações';
      return;
    }

    var count = null;
    var tab = getQuestionsTab();
    if (tab) {
      var tm = (tab.textContent || '').match(/(\d+)/);
      if (tm) count = parseInt(tm[1], 10);
    }

    if (count == null || isNaN(count)) {
      var widg = qs(root, '.jdgm-rev-widg');
      if (widg) {
        var attr = widg.getAttribute('data-number-of-questions');
        if (attr != null) count = parseInt(attr, 10);
      }
    }

    if (count == null || isNaN(count)) {
      count = qsa(document, '.jdgm-quest-widg__questions .jdgm-quest, .jdgm-quest').length;
    }

    var base = 'Ver todas as perguntas';
    label.textContent = count > 0 ? base + ' (' + count + ')' : base;
  }

  function bindQuestionFormEvents(root) {
    if (root.dataset.maxiFormBound === 'true') return;
    root.dataset.maxiFormBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        var cancel = event.target.closest && event.target.closest('.jdgm-cancel-question');
        if (!cancel) return;
        if (!root.contains(cancel) && !cancel.closest('.jdgm-question-form-wrapper')) return;
        event.preventDefault();
        closeQuestionForm(root);
      },
      true
    );

    // Garante product id ANTES do AJAX do Judge.me (ele usa closest('.jdgm-review-widget'))
    document.addEventListener(
      'click',
      function (event) {
        var submit = event.target.closest && event.target.closest('.jdgm-submit-question');
        if (!submit) return;
        var form = submit.closest('.jdgm-question-form');
        if (!form) return;
        var wrap = form.closest('.jdgm-question-form-wrapper') || form;
        ensureQuestionProductShell(root, wrap);
        patchJudgeQuestionProductBinding(root);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest && event.target.closest('.jdgm-question-form');
        if (!form) return;

        ensureQuestionProductShell(root, form.closest('.jdgm-question-form-wrapper') || form);
        patchJudgeQuestionProductBinding(root);

        clearAskInput(root);
        showAskStatus(root, 'Pergunta enviada');
        hideJudgeQuestionSuccess(root);
        closeQuestionForm(root);

        window.setTimeout(function () {
          hideJudgeQuestionSuccess(root);
          closeQuestionForm(root);
          if (questionsAreLoaded()) {
            setQuestionsMode(root, true);
          } else {
            updateQuestionsCount(root);
          }
        }, 600);

        window.setTimeout(function () {
          hideJudgeQuestionSuccess(root);
        }, 1200);
        window.setTimeout(function () {
          hideJudgeQuestionSuccess(root);
        }, 2500);
      },
      true
    );
  }

  function restyleVerified(root) {
    qsa(root, '.jdgm-rev__buyer-badge, .jm-verified-buyer-badge, .jm-verified-buyer-badge__text, [class*="buyer-badge"]').forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (!text || /verificado|verified|compra verificada/i.test(text)) {
        node.textContent = 'Compra verificada';
      }
      node.style.setProperty('color', '#1f9d55', 'important');
      node.style.setProperty('background', 'transparent', 'important');
    });

    // Badge vazio via ::before — força texto legível
    qsa(root, '.jdgm-rev__buyer-badge-wrapper').forEach(function (wrap) {
      var badge = qs(wrap, '.jdgm-rev__buyer-badge');
      if (!badge) return;
      if (!(badge.textContent || '').trim()) {
        badge.textContent = 'Compra verificada';
      }
    });
  }

  function hydrateGalleryImages(row) {
    qsa(row, '.jdgm-gallery__thumbnail').forEach(function (img) {
      var src = img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
      if (src && !img.getAttribute('src')) {
        img.setAttribute('src', src);
      }
      if (img.parentElement) {
        img.parentElement.classList.remove('jdgm--loading');
      }
      img.classList.remove('jdgm--loading');
    });
  }

  function openReviewsWithPhotos(root) {
    setQuestionsMode(root, false);
    closeQuestionForm(root);

    // Mesmo comportamento do “Ver mais” nativo: abre o lightbox da galeria
    var first =
      qs(root, '.jdgm-gallery__thumbnail-link') ||
      qs(document, '.jdgm-gallery__thumbnail-link');
    if (first) {
      first.click();
      return;
    }

    // Fallback: filtra avaliações com foto no Judge.me
    var sel =
      qs(root, '.jdgm-sort-dropdown') ||
      qs(document, '.jdgm-sort-dropdown');
    if (!sel) return;

    sel.value = 'with-pictures';
    try {
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jdgm && window.jdgm.jQuery) {
        window.jdgm.jQuery(sel).trigger('change');
      }
    } catch (e) {}

    root.setAttribute('data-maxi-visible', '9');
    window.setTimeout(function () {
      restyleVerified(root);
      applyReviewPaging(root);
    }, 400);
  }

  function mountMediaGallery(root) {
    var row =
      qs(root, '.jdgm-row-media') ||
      qs(document, '.jdgm-row-media');
    if (!row) return;

    // NÃO mover a galeria do DOM do Judge.me — isso quebra o lightbox (tela preta)
    hydrateGalleryImages(row);

    var gallery = qs(row, '.jdgm-gallery');
    var wrap = qs(row, '.jdgm-gallery-wrapper') || row;
    if (!gallery) return;

    var rowWrap = qs(wrap, '.maxi-qa__media-row');
    if (!rowWrap) {
      rowWrap = document.createElement('div');
      rowWrap.className = 'maxi-qa__media-row';
      if (gallery.parentElement === wrap) {
        wrap.insertBefore(rowWrap, gallery);
      } else {
        gallery.parentElement.insertBefore(rowWrap, gallery);
      }
      rowWrap.appendChild(gallery);
    } else if (gallery.parentElement !== rowWrap) {
      rowWrap.appendChild(gallery);
    }

    var more = qs(root, '[data-maxi-media-more]') || qs(row, '[data-maxi-media-more]');
    if (!more) {
      more = document.createElement('button');
      more.type = 'button';
      more.className = 'maxi-qa__media-more';
      more.setAttribute('data-maxi-media-more', '');
      more.innerHTML = 'avaliações<br>com fotos';
      rowWrap.appendChild(more);
      more.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openReviewsWithPhotos(root);
      });
    } else {
      if (more.parentElement !== rowWrap) {
        rowWrap.appendChild(more);
      }
      more.innerHTML = 'avaliações<br>com fotos';
    }
  }

  function openWriteReview(root) {
    var host = qs(root, '[data-maxi-reviews-host]') || root;
    var write =
      qs(host, '.jdgm-write-rev-link') ||
      qs(document, '.jdgm-write-rev-link') ||
      qs(host, 'a[href*="write"]');

    if (write) {
      write.click();
      return;
    }

    // Fallback: dispara evento Judge.me se disponível
    try {
      if (window.jdgm && typeof window.jdgm.openReviewForm === 'function') {
        window.jdgm.openReviewForm();
      }
    } catch (e) {}
  }

  function applyReviewPaging(root) {
    var reviews = getReviewItems(root);
    var btn = qs(root, '[data-maxi-load-more]');
    var visible = parseInt(root.getAttribute('data-maxi-visible') || String(PAGE_SIZE), 10);
    if (isNaN(visible) || visible < PAGE_SIZE) visible = PAGE_SIZE;

    reviews.forEach(function (rev, index) {
      rev.classList.toggle('maxi-qa-rev-hidden', index >= visible);
    });

    if (!btn) return;

    var reported = getReportedTotal(root);
    var jmMore = getJudgeLoadMore(root);
    var hasMoreInDom = visible < reviews.length;
    var hasMoreRemote = !!(jmMore && (!reported || reviews.length < reported));

    if (reviews.length === 0 && !hasMoreRemote) {
      btn.hidden = true;
      return;
    }

    if (hasMoreInDom || hasMoreRemote) {
      btn.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Carregar mais';
    } else {
      btn.hidden = true;
    }
  }

  function waitForMoreReviews(root, beforeCount, done) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var now = getReviewItems(root).length;
      if (now > beforeCount || tries >= 40) {
        window.clearInterval(timer);
        done(now > beforeCount);
      }
    }, 150);
  }

  function handleLoadMore(root) {
    var btn = qs(root, '[data-maxi-load-more]');
    var reviews = getReviewItems(root);
    var current = parseInt(root.getAttribute('data-maxi-visible') || String(PAGE_SIZE), 10);
    if (isNaN(current)) current = PAGE_SIZE;

    root.classList.remove('is-showing-questions');
    updateSectionTitle(root, false);
    clearPanelInlineStyles();

    // Ainda há itens ocultos no DOM
    if (current < reviews.length) {
      root.setAttribute('data-maxi-visible', String(current + PAGE_SIZE));
      applyReviewPaging(root);
      return;
    }

    // Precisa pedir a próxima página ao Judge.me
    var jmMore = getJudgeLoadMore(root);
    if (!jmMore) {
      root.setAttribute('data-maxi-visible', String(reviews.length));
      applyReviewPaging(root);
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Carregando...';
    }

    var before = reviews.length;
    jmMore.click();

    waitForMoreReviews(root, before, function (ok) {
      if (btn) btn.disabled = false;
      if (ok) {
        root.setAttribute('data-maxi-visible', String(current + PAGE_SIZE));
      }
      restyleVerified(root);
      applyReviewPaging(root);
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.maxiBound === 'true') return;
    root.dataset.maxiBound = 'true';
    root.setAttribute('data-maxi-visible', String(PAGE_SIZE));

    var form = qs(root, '[data-maxi-qa-form]');
    function submitQuestion() {
      var input = qs(form, 'input[name="question"]');
      var value = input ? String(input.value || '').trim() : '';
      if (!value) {
        if (input) input.focus();
        return;
      }
      openAskQuestion(root, value);
    }
    if (form) {
      var submitBtn = qs(form, '[data-maxi-qa-submit], .maxi-qa__ask-submit');
      if (submitBtn) {
        submitBtn.addEventListener('click', function (event) {
          event.preventDefault();
          submitQuestion();
        });
      }
      var input = qs(form, 'input[name="question"]');
      if (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitQuestion();
          }
        });
      }
    }

    var allBtn = qs(root, '[data-maxi-qa-all]');
    if (allBtn) {
      allBtn.addEventListener('click', function () {
        showAllQuestions(root);
      });
    }

    var loadMore = qs(root, '[data-maxi-load-more]');
    if (loadMore) {
      loadMore.addEventListener('click', function () {
        handleLoadMore(root);
      });
    }

    var writeBtn = qs(root, '[data-maxi-write-review]');
    if (writeBtn) {
      writeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        openWriteReview(root);
      });
    }

    bindQuestionFormEvents(root);
    preventHashVisits(root);
    neutralizeJudgeAnchors(root);
    enhance(root);
  }

  function enhance(root) {
    restyleVerified(root);
    updateSectionTitle(root, root.classList.contains('is-showing-questions'));
    updateQuestionsCount(root);
    applyReviewPaging(root);
    neutralizeJudgeAnchors(root);
    mountMediaGallery(root);
    hydrateReviewPicImages(root);
    patchJudgeQuestionProductBinding(root);
    hideJudgeQuestionSuccess(root);
    enhanceJudgePreviewBadge();
  }

  function hydrateReviewPicImages(root) {
    qsa(root, '.jdgm-rev__pics .jdgm-rev__pic-link').forEach(function (link) {
      var img = qs(link, 'img');
      if (!img) return;
      var thumb = img.getAttribute('data-src') || img.getAttribute('src');
      if (thumb && !img.getAttribute('src')) {
        img.setAttribute('src', thumb);
      }
      link.classList.remove('jdgm--loading');
      img.classList.remove('jdgm--loading');
    });
  }

  function upgradeImageUrl(url) {
    if (!url) return url;
    return String(url).replace(/([?&])width=\d+/i, '$1width=1400');
  }

  function isReviewThumb(img) {
    if (!img || !img.closest) return false;
    if (img.closest('.jdgm-gallery-popup, .mfp-wrap, .mfp-container')) return false;
    return !!img.closest('.jdgm-rev__pics, .jdgm-gallery, .jdgm-gallery__thumbnail-link');
  }

  function fixLightboxImage(img) {
    if (!img || isReviewThumb(img)) return;

    var popup = img.closest('.jdgm-gallery-popup, .mfp-wrap, .mfp-container, .jm-mfp-carousel-wrapper');
    var isLightbox =
      !!popup ||
      img.classList.contains('mfp-img') ||
      img.classList.contains('jm-mfp-img') ||
      !!img.closest('.mfp-content');

    if (!isLightbox) return;

    var sourceLink =
      (popup && popup.querySelector('a[data-mfp-src], a[href*="review-images"]')) ||
      img.closest('a[data-mfp-src], a[href*="review-images"]');

    var full =
      img.getAttribute('data-mfp-src') ||
      (sourceLink && (sourceLink.getAttribute('data-mfp-src') || sourceLink.getAttribute('href'))) ||
      img.getAttribute('data-full-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('src');

    full = upgradeImageUrl(full);
    if (full) {
      img.setAttribute('src', full);
      img.removeAttribute('width');
      img.removeAttribute('height');
    }

    img.style.setProperty('width', 'auto', 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('max-width', '92vw', 'important');
    img.style.setProperty('max-height', '88vh', 'important');
    img.style.removeProperty('min-width');
    img.style.removeProperty('min-height');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('border-radius', '0', 'important');
  }

  function fixReviewLightboxImages() {
    document.querySelectorAll(
      '.jdgm-gallery-popup img, .mfp-wrap img, .mfp-img, .jm-mfp-img, .jm-mfp-carousel-wrapper img'
    ).forEach(fixLightboxImage);

    var carousel = document.querySelector('.jdgm-gallery-popup .jm-mfp-carousel-wrapper');
    if (carousel) {
      carousel.style.setProperty('display', 'flex', 'important');
      carousel.style.setProperty('align-items', 'center', 'important');
      carousel.style.setProperty('justify-content', 'center', 'important');
      carousel.style.setProperty('width', '100%', 'important');
      carousel.style.setProperty('min-height', '58vh', 'important');
    }
  }

  function watchReviewLightbox() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest(
        '.jdgm-gallery__thumbnail-link, .jdgm-rev__pic-link, .jdgm-rev__pic-img, .jm-mfp-img'
      );
      if (!target) return;
      window.setTimeout(fixReviewLightboxImages, 0);
      window.setTimeout(fixReviewLightboxImages, 80);
      window.setTimeout(fixReviewLightboxImages, 200);
      window.setTimeout(fixReviewLightboxImages, 450);
    });

    try {
      var popupObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            fixReviewLightboxImages();
            return;
          }
        }
      });
      popupObserver.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}

    window.setInterval(function () {
      if (document.querySelector('.jdgm-gallery-popup, .mfp-wrap')) {
        fixReviewLightboxImages();
      }
    }, 500);
  }

  function boot() {
    bindProductNavLinks();
    enhanceJudgePreviewBadge();
    qsa(document, '[data-maxi-qa]').forEach(function (root) {
      bindRoot(root);
      enhance(root);
      patchJudgeQuestionProductBinding(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      watchReviewLightbox();
    });
  } else {
    boot();
    watchReviewLightbox();
  }

  window.addEventListener('load', function () {
    window.setTimeout(boot, 500);
    window.setTimeout(boot, 1500);
    window.setTimeout(boot, 3000);
    window.setTimeout(function () {
      qsa(document, '[data-maxi-qa]').forEach(patchJudgeQuestionProductBinding);
    }, 2000);
  });

  document.addEventListener('shopify:section:load', boot);

  try {
    var observer = new MutationObserver(function () {
      window.clearTimeout(observer._t);
      observer._t = window.setTimeout(function () {
        qsa(document, '[data-maxi-qa]').forEach(function (root) {
          if (root.classList.contains('is-asking')) return;
          if (root.classList.contains('is-showing-questions')) return;
          if (ensureQuestionsLoaded._busy) return;
          enhance(root);
        });
      }, 1200);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
